import React from 'react';
import { Link, Typography } from '@mui/material';
import { isUndefined } from 'lodash';
import UsersTemplate from 'assets/files/UsersTemplate.xlsx';
import { CREATE_USERS, DOWNLOAD_TEMPLATE, FILE_MAX_SIZE_MSG, UPLOAD_TEMPLATE_MSG } from 'common/constants/user';
import { DropZone } from 'components/';
import { BulkAddDialogProps } from './types';
import { validSpreadsheetTypes } from '../../../constants';
import ActionButtonGroup from '../../ActionButtonGroup';
import ActionDialog from '../../ActionDialog';

const BulkAddDialog = ({
  firm,
  resetDropzone,
  dialogUserData,
  newUsers,
  readFile,
  titleArray,
  displayMessageBox,
  selectedCompany,
  companyList,
  fundList,
}: BulkAddDialogProps) => (
  <ActionDialog
    title="BULK ADD USERS"
    subtitle={firm.name}
    handleDialogClose={resetDropzone}
    open={dialogUserData.open}>
    <div style={{ marginBottom: '1rem' }}>
      <Typography variant="body2">{UPLOAD_TEMPLATE_MSG}</Typography>
      <Link href={UsersTemplate} variant="body2" download="UsersTemplate">
        {DOWNLOAD_TEMPLATE}
      </Link>
    </div>
    {isUndefined(newUsers) ? (
      <DropZone
        setFileSrc={readFile}
        subTitle={FILE_MAX_SIZE_MSG}
        acceptFileTypes="application/*"
        validFileTypes={validSpreadsheetTypes}
        maxSizeAllowedInMb={1}
        titleArray={titleArray}
        allowMultipleFiles={false}
      />
    ) : (
      displayMessageBox()
    )}
    <ActionButtonGroup
      handleDialogClose={resetDropzone}
      createButtonText={CREATE_USERS}
      disableCreate={isUndefined(newUsers) || newUsers.length === 0}
      firm={firm}
      selectedCompany={selectedCompany}
      newUsers={newUsers}
      companyList={companyList}
      fundList={fundList}
    />
  </ActionDialog>
);

export default BulkAddDialog;
